import { Provider as AnalyticsProvider } from '@carvana/analytics';
import { ConsentProvider, ConsentKeys } from '@carvana/core-consent';
import { AnalyticsProvider as EventableAnalytics } from '@carvana/eventable-clickstream';
import React from 'react';
import AnalyticsConfig from '|/app/services/analytics';
import { LaunchDarklyProvider } from '|/app/services/launch-darkly';
import { ExperimentProvider } from '|/helpers/experiment';
import {
  DevicePlatformProvider,
  MobileNavigationRailContextProvider,
  PurchaseProvider,
  SummaryContextProvider,
  SupportContactMfeContextProvider,
  UserInitializationProvider,
  NavigationAnalyticsContextProvider,
  NavigationBlockContextProvider
} from '.';
import { ModalContextProvider } from '../app/modals';
import { SimpleAppFrameworkContextProvider } from '../helpers/app-framework';
import { FormStateContextProvider } from '.';

const defaultProps = {
  devicePlatform: ''
};

const SiteProviders: React.FC<React.PropsWithChildren<typeof defaultProps>> = ({
  devicePlatform,
  children
}) => (
  <EventableAnalytics environment={process.env.NODE_ENV} projectName="PurchaseUI" track="TXN">
    <ConsentProvider
      environment={process.env.CVNA_APP_ENVIRONMENT}
      track="TXN"
      projectName="PurchaseUI"
      consentsRequired={[
        ConsentKeys.HardPull,
        ConsentKeys.Jumio,
        ConsentKeys.SeeMyTermsAgreement,
        ConsentKeys.CosignerSeeMyTermsAgreement,
        ConsentKeys.SoftPull,
        ConsentKeys.RootInsurance,
        ConsentKeys.CreateAccount,
        ConsentKeys.Esign,
        ConsentKeys.NRSF,
        ConsentKeys.MarylandNRSF
      ]}
    >
      <LaunchDarklyProvider>
        <ExperimentProvider>
          <UserInitializationProvider>
            <DevicePlatformProvider platform={devicePlatform}>
              <PurchaseProvider>
                <MobileNavigationRailContextProvider>
                  <SimpleAppFrameworkContextProvider>
                    <NavigationAnalyticsContextProvider>
                      <NavigationBlockContextProvider>
                        <ModalContextProvider>
                          <SummaryContextProvider>
                            <SupportContactMfeContextProvider>
                              <AnalyticsProvider configs={AnalyticsConfig}>
                                <FormStateContextProvider>{children}</FormStateContextProvider>
                              </AnalyticsProvider>
                            </SupportContactMfeContextProvider>
                          </SummaryContextProvider>
                        </ModalContextProvider>
                      </NavigationBlockContextProvider>
                    </NavigationAnalyticsContextProvider>
                  </SimpleAppFrameworkContextProvider>
                </MobileNavigationRailContextProvider>
              </PurchaseProvider>
            </DevicePlatformProvider>
          </UserInitializationProvider>
        </ExperimentProvider>
      </LaunchDarklyProvider>
    </ConsentProvider>
  </EventableAnalytics>
);

export default SiteProviders;
